(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chad-testimonials-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeTestimonialsSection(sectionElement) {
      if (!sectionElement) return;

      var dialog = sectionElement.querySelector(
        '[data-testimonial-video-dialog]'
      );

      var iframe = sectionElement.querySelector(
        '[data-testimonial-video-frame]'
      );

      var openButtons = sectionElement.querySelectorAll(
        '[data-testimonial-video-open]'
      );

      var closeButton = sectionElement.querySelector(
        '[data-testimonial-video-close]'
      );

      if (!dialog || !iframe || dialog.dataset.initialized === 'true') {
        return;
      }

      dialog.dataset.initialized = 'true';

      function closeVideo() {
        iframe.src = '';

        if (dialog.open) {
          dialog.close();
        }
      }

      openButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var videoSource = button.getAttribute('data-video-src');

          if (!videoSource) return;

          iframe.src = videoSource;

          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        });
      });

      if (closeButton) {
        closeButton.addEventListener('click', closeVideo);
      }

      dialog.addEventListener('close', function () {
        iframe.src = '';
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
          closeVideo();
        }
      });
    }

    initializeTestimonialsSection(
      document.getElementById('ChadTestimonials-{{ section.id }}')
    );

    document.addEventListener('shopify:section:load', function (event) {
      if (
        event.target &&
        event.target.id === 'ChadTestimonials-{{ section.id }}'
      ) {
        initializeTestimonialsSection(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chad-video-gallery-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeVideoGallery(sectionElement) {
      if (!sectionElement) return;

      var dialog = sectionElement.querySelector(
        '[data-video-gallery-dialog]'
      );

      var videoFrame = sectionElement.querySelector(
        '[data-video-gallery-frame]'
      );

      var videoButtons = sectionElement.querySelectorAll(
        '[data-video-gallery-open]'
      );

      var closeButton = sectionElement.querySelector(
        '[data-video-gallery-close]'
      );

      var loadMoreButton = sectionElement.querySelector(
        '[data-video-gallery-load-more]'
      );

      function closeVideo() {
        if (videoFrame) {
          videoFrame.src = '';
        }

        if (dialog && dialog.open) {
          dialog.close();
        }
      }

      if (
        dialog &&
        videoFrame &&
        dialog.dataset.initialized !== 'true'
      ) {
        dialog.dataset.initialized = 'true';

        videoButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            var videoSource = button.getAttribute('data-video-src');

            if (!videoSource) return;

            videoFrame.src = videoSource;

            if (typeof dialog.showModal === 'function') {
              dialog.showModal();
            } else {
              dialog.setAttribute('open', '');
            }
          });
        });

        if (closeButton) {
          closeButton.addEventListener('click', closeVideo);
        }

        dialog.addEventListener('close', function () {
          videoFrame.src = '';
        });

        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) {
            closeVideo();
          }
        });
      }

      if (
        loadMoreButton &&
        loadMoreButton.dataset.initialized !== 'true'
      ) {
        loadMoreButton.dataset.initialized = 'true';

        loadMoreButton.addEventListener('click', function () {
          var hiddenVideos = sectionElement.querySelectorAll(
            '[data-video-gallery-item][hidden]'
          );

          hiddenVideos.forEach(function (videoItem, index) {
            videoItem.hidden = false;
            videoItem.removeAttribute('aria-hidden');
            videoItem.classList.remove(
              'chad-video-gallery__card--hidden'
            );

            window.setTimeout(function () {
              videoItem.classList.add(
                'chad-video-gallery__card--revealed'
              );
            }, index * 45);
          });

          loadMoreButton.hidden = true;
        });
      }
    }

    initializeVideoGallery(
      document.getElementById('ChadVideoGallery-{{ section.id }}')
    );

    document.addEventListener('shopify:section:load', function (event) {
      if (
        event.target &&
        event.target.id === 'ChadVideoGallery-{{ section.id }}'
      ) {
        initializeVideoGallery(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
